(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.schemeRest = this.getAttribute('data-scheme-rest');
      this.schemeScrolled = this.getAttribute('data-scheme-scrolled') || this.schemeRest;
      this.invertLogo = this.getAttribute('data-invert-logo') === 'true';
      this.colorScrolled = false;
      this._isSchemeScrolled = false;
      this.colorEnterY = 80;
      this.colorExitY = 24;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.updateColorFromScroll(window.pageYOffset || document.documentElement.scrollTop);
    }

    updateColorFromScroll(scrollTop) {
      if (this.colorScrolled) {
        if (scrollTop < this.colorExitY) {
          this.colorScrolled = false;
          this.setScrolledScheme(false);
          this.header.classList.remove('scrolled-past-header');
        }
      } else if (scrollTop > this.colorEnterY) {
        this.colorScrolled = true;
        this.setScrolledScheme(true);
        this.header.classList.add('scrolled-past-header');
      }
    }

    setScrolledScheme(isScrolled) {
      if (!this.schemeRest || !this.schemeScrolled || this.schemeRest === this.schemeScrolled) {
        this.classList.remove('coast-range-header--logo-invert');
        this._isSchemeScrolled = false;
        return;
      }

      if (this._isSchemeScrolled === isScrolled) return;
      this._isSchemeScrolled = isScrolled;

      if (isScrolled) {
        this.classList.remove(`color-${this.schemeRest}`);
        this.classList.add(`color-${this.schemeScrolled}`);
      } else {
        this.classList.remove(`color-${this.schemeScrolled}`);
        this.classList.add(`color-${this.schemeRest}`);
      }

      this.classList.toggle('coast-range-header--logo-invert', Boolean(isScrolled && this.invertLogo));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    setHeaderBounds() {
      if (!this.header) return;
      const rect = this.header.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.headerBounds = {
        top: rect.top + scrollTop,
        bottom: rect.bottom + scrollTop,
        height: rect.height,
        width: rect.width,
        left: rect.left,
        right: rect.right,
      };
    }

    createObserver() {
      this.setHeaderBounds();

      let observer = new IntersectionObserver((entries, observer) => {
        const entry = entries[0];
        if (entry && entry.boundingClientRect && entry.boundingClientRect.height > 0) {
          this.setHeaderBounds();
        }
        observer.disconnect();
      });

      observer.observe(this.header);
      window.addEventListener('resize', this.setHeaderBounds.bind(this));
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.updateColorFromScroll(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) {
          this.currentScrollTop = scrollTop;
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project"] && !Shopify.designMode) return;
  try {
    
  var grid = document.querySelector('.masonry-grid');
  var msnry;
  
  imagesLoaded( grid, function() {
    // init Isotope after all images have loaded
    msnry = new Masonry( grid, {
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: false,
      gutter: 10,
      fitWidth: true
    });
  });

  } catch(e) { console.error(e); }
})();
})();
